document.addEventListener('BSS:changeVariantQV', (e) => {
    setTimeout(() => {
        const productForm = document.querySelector('[bss-b2b-main-product-form], [bss-b2b-quickview-product-form]');
        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
    }, 500);
});

document.addEventListener('DOMContentLoaded', function () {
    if (typeof BSS_B2B !== 'undefined' && BSS_B2B) {
        setTimeout(() => {
            const observer = new MutationObserver((MutationList) => {
                for (let item of MutationList) {
                    if (item.target.classList?.contains('klaviyo-star-rating-widget')) {
                        setTimeout(() => {
                            document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
                        }, 1000);
                    }

                    if (item.target.classList?.contains('search-result-wrapper')) {
                        window.dispatchEvent(new Event("scroll"));    
                    }
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        }, 300);
    }
});
